<router-outlet></router-outlet>
<p-confirmDialog  rejectButtonStyleClass="p-button-text"></p-confirmDialog>
<div *ngIf="appService.loading"  class="progress-spinner"  style="z-index:999999999;">
  <p-progressSpinner></p-progressSpinner>
</div>
<p-toast></p-toast>
